import { BaseSystemModel, Guid, RecursivePartial } from '@models/base';
import { KanbanBoardQuickfilter } from './kanban-board-quickfilter';

export class KanbanBoard extends BaseSystemModel {
    _type = BaseSystemModel.Type.KanbanBoard;

    name: string = 'KB';
    filter?: string;
    sort?: string;
    projectId?: Guid;
    orgId?: string;
    quickFilters?: KanbanBoardQuickfilter[];
    personal?: boolean;
    stateIds?: Guid[];
    workflowId?: Guid;

    constructor(json?: RecursivePartial<KanbanBoard>) {
        super(json);
        this.parseKanbanBoard(json || {});
    }

    parse(json: RecursivePartial<KanbanBoard>): KanbanBoard {
        super.parse(json);
        this.parseKanbanBoard(json);
        return this;
    }

    private parseKanbanBoard(json: RecursivePartial<KanbanBoard>): void {
        KanbanBoard.assignFields<KanbanBoard>(this, json, ['name', 'filter', 'sort', 'projectId', 'orgId', 'personal', 'workflowId']);
        KanbanBoard.assignArrays<KanbanBoard>(this, json, ['stateIds']);
        KanbanBoard.assignClassArrays<KanbanBoard>(this, json, { quickFilters: KanbanBoardQuickfilter });
        if (this.quickFilters?.length) {
            let i = 1;
            this.quickFilters.forEach(qf => {
                if (!qf.id) {
                    qf.id = '' + (i++)
                }
            });
        }
    }

}
